import actions from './actions'
import mutations from './mutations'
import getters from './getters'
export default {
    state: {
        warnings: [],
        warning_pages: 0,
        newWarning: {
            color: "#111111",
            public: "1"
        }
    },
    actions,
    mutations,
    getters
}
